export default __webpack_public_path__ + "f205c6fc3ba5d2385b5a882913b78742.png";